<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<m-search v-if="power('7')" @search="updateList">
				<c-form>
					<c-form-item type="input" label="项目名称" name="project_name"></c-form-item>
					<c-form-item type="select" label="业主单位" name="yzdw_name" options="OWNER_UNIT"></c-form-item>
					<c-form-item type="select" label="监理单位" name="jldw_name" options="SUPERVISE_UNIT"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate v-if="power('7')">
				<c-button icon="add" @click="navigateTo('/transact/proceed/apply', true)">我要申请开工令</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="签署状态"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="proceedState[data.state]" :style="{'color': proceedState[data.state].color}">{{proceedState[data.state].name}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="项目名称"
					name="project_name"
					width="180"
				></c-table-column>
				
				<c-table-column
					label="业主单位"
					name="yzdw_name"
					width="180"
				></c-table-column>
				
				<c-table-column
					label="监理单位"
					name="jldw_name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
					width="160"
				></c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="140"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.state == 4 && power('7')" @click="navigateTo('/transact/proceed/edit', {id: data.id}, true)">重新编辑</c-table-button>
						<c-table-button v-if="data.state == 1 && power('8')" @click="navigateTo('/transact/proceed/detail', {id: data.id}, true)">审批</c-table-button>
						<c-table-button v-else @click="navigateTo('/transact/proceed/detail', {id: data.id}, true)">详情</c-table-button>
						<c-table-button v-if="data.state == 3 && power('7')" @click="downloadHandle(data)">下载</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</menu-aside>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		computed: {
			...mapGetters(['power', 'proceedState'])
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList(data) {
				this.$refs.table.load({
					url: '/project/kgl/list',
					data
				});
			},
			
			downloadHandle(data) {
				window.open(data.kgl_path);
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
